import { Action } from '@ngrx/store';
import {
    LIVEVIEW_ORDER_FETCH,
    LIVEVIEW_ORDER_FETCHING_SET,
    LIVEVIEW_ORDER_FOCUSED_SET,
    LIVEVIEW_ORDER_VIEWED_SET,
    LIVEVIEW_ORDERS_POLLING_START,
    LIVEVIEW_ORDERS_POLLING_STOP,
    LIVEVIEW_ORDERS_SEARCH
} from '../action-types';
import { SearchDeliveryOrdersRequest } from '@core/models/delivery/search-delivery-orders-request';
import { FilterSetAction, ListItemSetAction, ListItemUnsetAction, ListMergeAction, ListSetAction, ListSetFetchingAction } from '../shared/list/list.actions';
import { SharedAction } from '../shared/actions/shared-action';
import { GROUP_LIVEVIEW_ORDERS } from '../state-groups';
import { DELIVERY_ORDER_ENTITY } from '../entity-types';

export class SearchLiveViewOrdersAction implements Action {
    readonly type = LIVEVIEW_ORDERS_SEARCH;

    constructor(
        public payload?: {
            request?: SearchDeliveryOrdersRequest;
            perPage?: number;
            isFetching?: boolean;
            ignoreRemotePreferencesUpdate?: boolean;
            trackingIds?: string[];
        }
    ) {}
}

export class SetLiveViewOrdersAction extends ListSetAction implements SharedAction {
    name = GROUP_LIVEVIEW_ORDERS;

    constructor(payload: any) {
        super(payload);
        payload.domain = DELIVERY_ORDER_ENTITY;
    }
}

export class MergeDeliveryOrdersAction extends ListMergeAction implements SharedAction {
    name = GROUP_LIVEVIEW_ORDERS;

    constructor(payload: any) {
        super(payload);
        payload.domain = DELIVERY_ORDER_ENTITY;
    }
}

export class SetLiveViewOrdersFetchingAction
    extends ListSetFetchingAction
    implements SharedAction {
    name = GROUP_LIVEVIEW_ORDERS;

    constructor(payload: any) {
        super(payload);
    }
}

export class SetLiveViewOrdersFilterByAction
    extends FilterSetAction
    implements SharedAction {
    name = GROUP_LIVEVIEW_ORDERS;

    constructor(payload: any) {
        super(payload);
        payload.domain = DELIVERY_ORDER_ENTITY;
    }
}

export class SetLiveViewOrderFetchingAction
    implements Action {

    readonly type = LIVEVIEW_ORDER_FETCHING_SET;
    constructor(public payload: { value: boolean }) {
    }
}

export class SetLiveViewOrderAction extends ListItemSetAction implements SharedAction {
    name = GROUP_LIVEVIEW_ORDERS;

    constructor(payload: any) {
        super(payload);
        payload.domain = DELIVERY_ORDER_ENTITY;
    }
}

export class UnsetDeliveryOrderAction
    extends ListItemUnsetAction
    implements SharedAction {
    name = GROUP_LIVEVIEW_ORDERS;

    constructor(payload: any) {
        super(payload);
        payload.domain = DELIVERY_ORDER_ENTITY;
    }
}

export class SetViewedLiveViewOrderAction implements Action {
    readonly type = LIVEVIEW_ORDER_VIEWED_SET;

    constructor(
        public payload: {
            orderId: string;
        }
    ) {}
}

export class FetchLiveViewDeliveryOrderAction implements Action {
    readonly type = LIVEVIEW_ORDER_FETCH;

    constructor(
        public payload: {
            orderId: string;
        }
    ) {}
}

export class StartLiveViewOrdersPollingAction implements Action {
    readonly type = LIVEVIEW_ORDERS_POLLING_START;
}

export class StopLiveViewOrdersPollingAction implements Action {
    readonly type = LIVEVIEW_ORDERS_POLLING_STOP;
}

export class SetIsOrderOnFocusAction implements Action {
    readonly type = LIVEVIEW_ORDER_FOCUSED_SET;

    constructor(
        public payload: {
            value: boolean;
        }
    ) {}
}
